export default function onFileChanged(e) {
    let files = e.target.files;
    let formData = new FormData();
    for (let file of files) formData.append("files", file, ß.convertFilename(file.name));
    this.uploadFormData(formData);
}
